<template>
  <div class="manual-page">
    <MainBg />
    <h2 class="manual-page__title">Red Bull Tournament</h2>
    <ManualTitle />
    <ManualDescription />
    <ManualSteps />
    <!-- <ManualPromo /> -->
    <ManualVideo />
    <ManualRunesDescription />
    <ManualMapBtn />
    <ManualSocials />
    <ManualRunes />
  </div>
</template>

<script>
import ManualDescription from "@/components/manual/ManualDescription";
import ManualRunesDescription from "@/components/manual/ManualRunesDescription";
import ManualSteps from "@/components/manual/ManualSteps";
import ManualVideo from "@/components/manual/ManualVideo";
import ManualMapBtn from "@/components/manual/ManualMapBtn";
// import ManualPromo from "@/components/manual/ManualPromo";
import ManualRunes from "@/components/manual/ManualRunes";
import ManualTitle from "@/components/manual/ManualTitle";
import ManualSocials from "@/components/manual/ManualSocials";
import MainBg from "@/components/common/MainBg";

export default {
  name: "Manual",
  components: {
    MainBg,
    ManualTitle,
    ManualSteps,
    ManualVideo,
    ManualMapBtn,
    ManualDescription,
    ManualRunesDescription,
    ManualSocials,
    // ManualPromo,
    ManualRunes
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss">
.manual-page {
  padding: 90px 0 90px;
  background-color: #000a25;
  background-size: 100% auto;
  position: relative;
  z-index: 1;

  &__title {
    font-family: "Montserrat";
    font-weight: 900;
    font-size: 52px;
    line-height: 1.15;
    letter-spacing: 0.02em;
    text-align: center;
    color: #fbc33e;
    margin-bottom: 1.5em;
  }

  @include breakpoint("sm-and-down") {
    padding: 45px 0 60px;
    &__title {
      font-size: 36px;
    }
  }
}
</style>
